// tasks that can be added to the Horizon Queue

export const WIDGET_ADD = "WIDGET_ADD";
export const WIDGET_REMOVE = "WIDGET_REMOVE";
export const SHOW_MODAL = "SHOW_MODAL";
export const SHOW_HELP = "SHOW_HELP";
export const POPUP_WIDGET_LAUNCH = "POPUP_WIDGET_LAUNCH";
export const UPDATE_DATA = "UPDATE_DATA";
